import { Worker, Viewer } from "@react-pdf-viewer/core";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
// import "../PTPCDownload/PTPCDocViewer.css";
import toast from "react-hot-toast";
import moment from "moment";
import axios from "axios";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { toolbarPlugin, ToolbarSlot } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { baseServiceUrl, urls } from "../environment";
import { useUserContext } from "../context/UserContext";
import { CloudDownload, Loader } from "lucide-react";
import useUserStore from "../stores/useUserStores";
type PDFViewerProps = {
  examId: number;
};

const PDFViewer: FC<PDFViewerProps> = ({ examId }): JSX.Element => {
  const FileDownload = require("js-file-download");
  // const theme = useTheme();
  // const isBelowMediumScreen = useMediaQuery("(max-width: 900px)");
  // const isAboveMediumScreen = useMediaQuery("(max-width: 1200px)");
  // const isBelowLargeScreen = useMediaQuery("(max-width: 1500px)");
  // const MyEnrolmentDetails = useSelector(
  //   (state: StoreState) => state.user.login_with_my_enrollmentdata
  // );

  const [file, setFile] = useState<any[]>([]);
  const [activedoc, setActiveDoc] = useState<any>();
  const userDetails = useUserStore();
  const [isError, setIsError] = useState<any>();
  // useEffect(() => {
  //   const payload = {
  //     govtId: getApplicationOfGovtId?.govt_id
  //   }
  //   if (getApplicationOfGovtId) {
  //     downloadCertificate(payload as any);
  //   } else {
  //     toast.error("Govermrnt number is missing. Please check your details.", {
  //       duration: 8000,
  //       style: {
  //         backgroundColor: "red",
  //         color: "white"
  //       },
  //       iconTheme: {
  //         primary: '#fff',
  //         secondary: '#F400A1',
  //       },
  //       ariaProps: {
  //         role: 'status',
  //         'aria-live': 'polite',
  //       },
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (!!file && file.length > 0) {
      setActiveDoc(file[0]);
    }
  }, [file]);
  const downloadCertificate = async () => {
    // dispatch(
    //   BeginApiCallAction({
    //     message: "Finding your Enrolment Certificate. Please wait...",
    //   })
    // );
    userDetails.setLoading(true);
    try {
      const response = await axios({
        url: `${baseServiceUrl}${urls.examViewPDF}`,
        method: "POST",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
        },
        data: {
          user_id: userDetails?.userdetail.id,
          exam_id: examId,
        },
      });
      const fileUrl = URL.createObjectURL(response.data);

      if (response.status === 200) {
        // Create a URL for the file

        FileDownload(response.data, "candidate-result.pdf");
        const fileUrl = URL.createObjectURL(response.data);
        const fileName = `examResult_${moment().format(
          "DDMMYYYY"
        )}_certificate.pdf`;

        // Set the file for the viewer
        setFile([{ uri: fileUrl, fileName: fileName, f: response.data }]);

        // toast.success("Certificate ready for viewing.");
      } else {
        toast.error("Something went wrong");
      }
    } catch (error: any) {
      showMessage(error?.response?.data);
    } finally {
      userDetails.setLoading(false);
      // dispatch(LoadingStopAction());
    }
  };
  const showMessage = async (payload: any) => {
    payload?.text().then((data: string) => {
      setIsError(JSON.parse(data));
      //   dispatch(
      //     ApiCallErrorAction(
      //       !!data
      //         ? JSON.parse(data)
      //         : { error: "Failed to download the certificate." }
      //     )
      //   );
      // });
    });
  };
  const download = () => {
    FileDownload(activedoc.f, activedoc.fileName);
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin({});

  useEffect(() => {
    if (examId) {
      downloadCertificate();
    }
  }, [examId]);
  return (
    <Grid container>
      <Grid item xs={11.5} pl={4}>
        {/* <DocViewer
          config={{
            header: { disableFileName: true, disableHeader: true },
          }}
          onDocumentChange={(data) => {
            setActiveDoc(data);
          }}
          style={{ backgroundColor: "#fff", borderRadius: 10 }}
          documents={file}
          pluginRenderers={DocViewerRenderers}
        /> */}

        {!!file && file.length ? (
          //  @ts-ignore
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
            <div style={{ height: "76vh" }}>
              <Viewer
                fileUrl={file[0].uri}
                plugins={[defaultLayoutPluginInstance]}
                defaultScale={1.1}
              />
            </div>
          </Worker>
        ) : userDetails.loading ? (
          <div className="w-full h-[84vh] flex items-center justify-center">
            <Loader className="size-8 text-gray-400 animate-spin" />
          </div>
        ) : (
          <></>
        )}
      </Grid>

      {isError ? (
        <Grid
          item
          xs={11.8}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 10,
          }}
        >
          <Box
            className="w-11/12 mx-auto"
            sx={{
              display: "flex",
              flexDirection: "column",
              border: "1px solid red",
              height: 100,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 2,
              py: 5,
              backgroundColor: "#fff",
            }}
          >
            {/* <img
              src={ErrorImage}
              alt="No Data Found"
              style={{ width: 80, height: 80 }}
            /> */}
            <Typography
              sx={{
                color: "red",
                fontSize: 18,
                fontWeight: "600",
                mt: 1,
              }}
            >
              {isError?.message}
            </Typography>
          </Box>
        </Grid>
      ) : (
        <Grid
          item
          xs={11.5}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {!!file && file.length ? (
            <button
              onClick={() => download()}
              className="flex items-center justify-center gap-x-2 bg-white border  border-blue-500 hover:bg-blue-200 px-5 py-1 mt-2 rounded-md"
            >
              <CloudDownload className="size-5 text-blue-500" />
              <p className="text-blue-500 font-semibold">Download</p>
            </button>
          ) : (
            <></>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default PDFViewer;
